import api from "Helpers/Api";
import { FairsListRequest, FairsListResponse } from "Services/Fairs/fairs";

export default async function fairsList(params: FairsListRequest) {
  const { data } = await api.get<FairsListResponse>(`fairs/list`, { params });

  return data;
}
